<template>
  <v-card :class="classP" :disabled="disabled" :loading="loading">
    <v-card-text
      :class="
        'card-text text-center ' +
          type +
          (active ? ' active' : '') +
          (savitarna ? ' savitarna' : '')
      "
    >
      <v-icon :class="'bg-icon ' + type + (savitarna ? ' savitarna' : '')">{{
        icon
      }}</v-icon>
      <v-icon
        :class="
          'main-icon ' +
            type +
            (active ? ' active' : '') +
            (savitarna ? ' savitarna' : '')
        "
        >{{ icon }}</v-icon
      >
      <!-- <v-fade-transition v-if="!active">
        <v-overlay absolute> </v-overlay>
      </v-fade-transition> -->
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ElTipasIcon',
  props: {
    classP: String,
    disabled: Boolean,
    loading: Boolean,
    active: Boolean,
    savitarna: Boolean,
    icon: String,
    type: String,
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';

.card-text {
  background: $backgroundIcon;
  align-items: center;
  position: relative;
  overflow: hidden;

  &.sutartis {
    background: $sutartisBackgroundIcon;
  }
  &.sandoris {
    background: $sandorisBackgroundIcon;
  }
  &.perleidimas {
    background: $perleidimasBackgroundIcon;
  }
  &.prasymas {
    background: $prasymasBackgroundIcon;
  }

  &.active {
    background: $activeIcon;

    &.sutartis {
      background: $sutartisActiveIcon;
    }
    &.sandoris {
      background: $sandorisActiveIcon;
    }
    &.perleidimas {
      background: $perleidimasActiveIcon;
    }
    &.prasymas {
      background: $prasymasActiveIcon;
    }
  }

  .bg-icon {
    position: absolute;
    top: 20%;
    left: 60%;
    color: $activeIcon;
    font-size: 150px;

    &.sutartis {
      color: $sutartisActiveIcon;
    }
    &.sandoris {
      color: $sandorisActiveIcon;
    }
    &.perleidimas {
      color: $perleidimasActiveIcon;
    }
    &.prasymas {
      color: $prasymasActiveIcon;
    }

    &.savitarna {
      font-size: 100px;
      left: 80%;
    }
  }

  .main-icon {
    color: $titleIcon;
    font-size: 80px;

    &.active {
      color: #eee;
    }

    &.savitarna {
      font-size: 30px;
    }
  }
  .overlay {
    color: #fff;
  }
}
</style>
